// define action types here...

const ACTION_ROOT = '/todolist/challenge/';

const SET_CURRENT_ITEM = `${ACTION_ROOT}SET_CURRENT_ITEM`;
const RESET_CURRENT_ITEM = `${ACTION_ROOT}RESET_CURRENT_ITEM`;
const TEXT_CHANGE = `${ACTION_ROOT}TEXT_CHANGE`;
const FETCH_LIST_ITEMS = `${ACTION_ROOT}FETCH_LIST_ITEMS`;
const FETCHED_LIST_ITEMS = `${ACTION_ROOT}FETCHED_LIST_ITEMS`;
const ADD_LIST_ITEM = `${ACTION_ROOT}ADD_LIST_ITEM`;
const EDIT_LIST_ITEM = `${ACTION_ROOT}EDIT_LIST_ITEM`;
const DELETE_LIST_ITEM = `${ACTION_ROOT}DELETE_LIST_ITEM`;
const FAILED_FETCH_LIST_ITEMS = `${ACTION_ROOT}FAILED_FETCH_LIST_ITEMS`;
const FAILED_ADD_LIST_ITEM = `${ACTION_ROOT}FAILED_ADD_LIST_ITEM`;
const FAILED_EDIT_LIST_ITEM = `${ACTION_ROOT}FAILED_EDIT_LIST_ITEM`;
const FAILED_DELETE_LIST_ITEM = `${ACTION_ROOT}FAILED_DELETE_LIST_ITEM`;

export {
  SET_CURRENT_ITEM,
  RESET_CURRENT_ITEM,
  TEXT_CHANGE,
  FETCH_LIST_ITEMS,
  FETCHED_LIST_ITEMS,
  ADD_LIST_ITEM,
  EDIT_LIST_ITEM,
  DELETE_LIST_ITEM,
  FAILED_FETCH_LIST_ITEMS,
  FAILED_ADD_LIST_ITEM,
  FAILED_EDIT_LIST_ITEM,
  FAILED_DELETE_LIST_ITEM,
};



// WEBPACK FOOTER //
// ./src/actions/types.js